import { render, staticRenderFns } from "./MultipleForm.vue?vue&type=template&id=6d720347&scoped=true&"
import script from "./MultipleForm.vue?vue&type=script&lang=js&"
export * from "./MultipleForm.vue?vue&type=script&lang=js&"
import style0 from "./MultipleForm.vue?vue&type=style&index=0&id=6d720347&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d720347",
  null
  
)

export default component.exports